module.exports = {"130602001":"先锋街道","130602002":"新市场街道","130602003":"东风街道","130602004":"建南街道","130602005":"韩村北路街道","130602200":"颉庄乡","130602201":"富昌乡","130602202":"韩村乡","130602203":"南奇乡","130602204":"江城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130602.json
// module id = 152
// module chunks = 0